export const namespace = 'sysparam'
